import styled, { css } from 'styled-components'

export const Row = styled.div<{ $isDropTarget?: boolean }>(
  ({ theme, $isDropTarget }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.space['12']};
    padding: ${theme.space['12']} ${theme.space['16']};
    background: ${$isDropTarget ? theme.colors.blue100 : theme.colors.white};
    border: ${theme.border.size['1']} solid
      ${$isDropTarget ? theme.colors.blue500 : theme.colors.gray400};
    border-radius: ${theme.border.radius['8']};
    max-width: 72rem;
    width: 100%;
    cursor: pointer;

    &:hover {
      border-color: ${theme.colors.gray600};
    }
  `,
)

export const DragHandle = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    cursor: grab;
    color: ${theme.colors.black300};
    flex-shrink: 0;
  `,
)

export const IconWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    flex-shrink: 0;
    color: ${theme.colors.black500};
  `,
)

export const RightSection = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.space['8']};
    margin-left: auto;
    flex-shrink: 0;
    height: ${theme.space['32']};
  `,
)
